
import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import style from './order-complete.module.scss';
import { Spinner, Col, Row, Button } from 'react-bootstrap';
import confirmIcon from '../../../../assets/confirm.svg';
import UserService from '../../../../services/user-service'
import { getTransactionId } from '../../../../helpr/authHelper';

const OrderComplete = ({session}) => {
  const userService = new UserService();
  const [ loading, setLoading ] = useState(false);
  /*
    Force Session to Expire and close order form window
  */
  const closeSession = () => {
    setLoading(true);
    async function  service(sessionId, email) {
      const resp = await userService.unregisterSession(email, sessionId);
      localStorage.clear();
      window.location.reload();
    }
    service(getTransactionId(), session['investorEmail']);
  }

  const windowReload = () => {
    window.location.reload();
  }
  return (
    <div className={style['order-summary']}>
      <Row>
        <Col>
          <div className={style['order-complete-panel']}>
            <div className={style['order-complete-panel-header']}>
              RESERVATION SUBMITTED
            </div>
            <div className={style['order-complete-panel-logo']}>
              <img src={confirmIcon} />
            </div>
            <div className={style['order-complete-panel-body']}>
              <div className={style['text-content']}>
                You have submitted your Application To Purchase (ATP)/Reservation to {session.sellingAgentDisplayName}.
              </div>
              <div className={style['text-content']}>
                A confirmation of your ATP submission has been sent to your email with the details of your ATP.
                Your selling agent {session.sellingAgentDisplayName} will contact you soon to confirm your reservation.
              </div>
              <div className={style['text-content']}>
                Please click RESERVE AGAIN if you wish to submit another ATP; otherwise please click END SESSION to
                exit the e-SIP.
              </div>
              <div className={style['btn-actions']}>
                <Button onClick={()=>windowReload()}>RESERVE AGAIN</Button>
                <Button className="btn-secondary" onClick={()=>closeSession()}>
                  { loading? <Spinner size="sm" animation="border"/>: "END SESSION" }
                </Button>
              </div>
            </div>
          </div>
        </Col>
      </Row>
    </div>
  )
}


export default OrderComplete;


